import React from 'react';
import PortfolioMonitorContextProvider, { usePortfolioMonitorContext }
  from '@/creditflowresearch/application/PortfolioMonitor/PortfolioMonitorContext';
import PortfoliosContextProvider, { usePortfoliosContext }
  from '@/creditflowresearch/application/PortfolioMonitor/PortfoliosContext';
import PortfolioContent from './PortfolioContent';
import getPortfolioMonitorOverlay from '@/creditflowresearch/ui/components/portfolioMonitor/getPortfolioMonitorOverlay';
import ManagePortfoliosContextProvider from '@/creditflowresearch/application/PortfolioMonitor/ManagePortfoliosContext';

const PortfolioMonitor = () => {
  const { isFormOpened } = usePortfolioMonitorContext();
  const { portfolioCollection } = usePortfoliosContext();

  return (
    !portfolioCollection.length && !isFormOpened
        ? getPortfolioMonitorOverlay(true, true)
        : <PortfolioContent />
  );
};

export default (props) => (
  <PortfoliosContextProvider purePortfoliosList={ props.purePortfoliosList }>
    <PortfolioMonitorContextProvider>
      <ManagePortfoliosContextProvider>
        <PortfolioMonitor { ...props } />
      </ManagePortfoliosContextProvider>
    </PortfolioMonitorContextProvider>
  </PortfoliosContextProvider>
);
